var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-text mb-2"},[_c('span',{staticClass:"icon has-text-info mr-2"},[_c('Icon',{staticClass:"is-greyBG-light",attrs:{"family":"fa","name":"fa-user"}})],1),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }